import { useStytch, useStytchSession, useStytchUser } from "@stytch/react";
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { checkIfUserTypeIsInternal } from "../helpers/checkIfUserTypeIsInternal";

import { apiEndpoints } from "../global/api/apiEndpoints";
import { setBorrowerProfileState } from "../redux/actions/borrowerProfileActions";
import { globalAlertFail } from "../redux/actions/globalAlertActions";
import { setIsLoadingFalse } from "../redux/actions/isLoadingActions";
import { logInUser } from "../redux/actions/isLoggedInActions";
import { setUserState } from "../redux/actions/userActions";
import { setUserType } from "../redux/actions/userTypeActions";
import { useAxiosHook } from "./useAxiosHook";
import { useBorrowerHook } from "./useBorrowerHook";
import { isNil } from "lodash";
import { setProfileState } from "../redux/actions/profileActions";
import { arrayProtector } from "../helpers/arrayProtector";
import { useBrokerDrilldownHook } from "./useBrokerDrilldownHook";
const errorInit = {
  status: null,
  message: null,
};
export const useAuthHook = () => {
  const { getIronFundSalesDropdownList, getUserProfileData, getAllUsers } = useBorrowerHook();
  const [authError, setAuthError] = useState(errorInit);

  const profile = useSelector((state) => state.profile);
  const globalData = useSelector((state) => state.globalData);
  const loanScenarios = useSelector((state) => state.loanScenarios);
  const { handleGetAndSetBrokerScenarios, isInternalEmployee } = useBrokerDrilldownHook();
  const { user } = useStytchUser();

  const { axiosPostIsLoading, axiosGetIsLoading, axiosPostRequest, axiosGetRequest } = useAxiosHook();
  const authIsLoading = axiosPostIsLoading || axiosGetIsLoading ? true : false;

  const { session } = useStytchSession();
  const stytch = useStytch();
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLoginUser = useCallback(async () => {
    /*
    - Params: none
    - Desc: finds email and user_id from Stytch, passes data to  POST to /login
        ex)  let data = {
                  emailAddress: email.toLowerCase(),
                  user_id: session.user_id,
                };
    - Response: 200
        handleFetchUserData() is run on 200 success
    */
    localStorage.removeItem("userData");
    localStorage.removeItem("userType");
    localStorage.removeItem("auth");
    localStorage.removeItem("ironLinc");

    let endpoint = "portal_login";
    let email = user?.emails[0]?.email;

    let data = {
      emailAddress: email,
      user_id: session.user_id,
    };

    const onSuccess = () => {
      dispatch(setUserType(user.trusted_metadata.userCategory));
      setAuthError(errorInit);
    };

    const onFail = () => {
      setAuthError({
        status: true,
        message: "Could not connect to the server, please try again later.",
      });

      dispatch(globalAlertFail("Could not login user."));
      stytch.session.revoke();
    };

    const params = {
      name: "Login",
      path: endpoint,
      payload: data,
      onSuccessFn: onSuccess,
      onFailFn: onFail,
      onFailMsg: "Could not log in",
    };
    await axiosPostRequest(params);
  }, []);

  const handleFetchUserData = async () => {
    const endpoint = `get_user_profile`;

    const onSuccess = (responseData) => {
      console.log("responseData", responseData);
      let userType = responseData?.userType;

      dispatch(setUserType(userType));
      dispatch(setBorrowerProfileState(responseData));
      dispatch(setUserState(responseData));
      dispatch(logInUser());

      dispatch(setIsLoadingFalse());
      setAuthError(errorInit);
    };

    const params = {
      name: "Get User Data",
      path: endpoint,
      onSuccessFn: onSuccess,
      // onFailFn: onFail,
      onFailMsg: "Could not log in",
    };
    await axiosGetRequest(params);
  };

  const handleRevokeSession = async () => {
    stytch.session.revoke();
  };

  const performRequiredRequests = async () => {
    if (isNil(profile)) {
      handleLoginUser();
      console.log("GetTTTTTTTTTTTTTTTT");
      getUserProfileData({ onSuccessFn: (d) => dispatch(setProfileState(d?.userProfile)) });
    }

    if (isNil(globalData?.employess)) {
      getIronFundSalesDropdownList({});
    }

    if (isInternalEmployee && isNil(globalData?.users)) {
      getAllUsers({});
    }

    if (isNil(loanScenarios) || arrayProtector(loanScenarios).length === 0) {
      handleGetAndSetBrokerScenarios();
    }
  };

  return {
    authIsLoading,
    authError,
    handleRevokeSession,
    handleLoginUser,
    handleFetchUserData,
    performRequiredRequests,
  };
};
